import { LIFE, LONG_TERM_CARE } from '../FinancialPlan/Insurance/InsuranceConstants';
import { INSURANCE_GOAL_TYPE } from './WhatIfsConstants';
import { ASSUMPTIONS } from '../FinancialPlan/Explanations/ExplanationsConst';

export default {
  retirement: 'RetirementWhatIfs',
  education: 'EducationWhatIfs',
  healthCare: 'HealthCareWhatIfs',
  emergencyfund: 'EmergencyFundWhatIfs',
  homePurchase: 'HomePurchaseWhatIfs',
  largePurchase: 'LargePurchaseWhatIfs',
  debtmanagement: 'DebtManagementWhatIfs',
  [`${INSURANCE_GOAL_TYPE}.${LIFE}`]: 'LifeInsuranceWhatIfs',
  [`${INSURANCE_GOAL_TYPE}.${LONG_TERM_CARE}`]: 'LtcInsuranceWhatIfs',
  [`${INSURANCE_GOAL_TYPE}.${ASSUMPTIONS}`]: 'LifeInsuranceWhatIfs',
  decumulation: 'DecumulationWhatIfs',
  estatePlanning: 'EstatePlanningWhatIfs',
  charitableGiving: 'CharitableGivingWhatIfs',
};
